import { render } from "./download.vue?vue&type=template&id=366eef50&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=366eef50&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/京南广告/cheyidai/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366eef50"]])

export default __exports__